import React from 'react';
import { Box, Typography, Chip, Tooltip, Button } from '@mui/material';

// Couleurs seuils (identique Dashboard)
function getColorForValue(value, thresholds) {
  if (value === null || value === undefined) return { bg: '#f3f6fa', text: '#222' };
  const numValue = parseFloat(value);
  if (isNaN(numValue)) return { bg: '#f3f6fa', text: '#222' };
  if (numValue >= thresholds.high) return { bg: '#e8f5e9', text: '#2e7d32' };
  if (numValue >= thresholds.medium) return { bg: '#fff3e0', text: '#ef6c00' };
  return { bg: '#ffebee', text: '#c62828' };
}

// Format date DD/MM/YY
function formatDateShort(dateStr) {
  if (!dateStr) return '-';
  const d = new Date(dateStr);
  const day = d.getDate().toString().padStart(2, '0');
  const month = (d.getMonth() + 1).toString().padStart(2, '0');
  const year = d.getFullYear().toString().slice(-2);
  return `${day}/${month}/${year}`;
}

// Mapping pays -> drapeau
const countryFlags = {
  FR: 'https://flagcdn.com/16x12/fr.png',
  ES: 'https://flagcdn.com/16x12/es.png',
  IT: 'https://flagcdn.com/16x12/it.png',
  DE: 'https://flagcdn.com/16x12/de.png',
  UK: 'https://flagcdn.com/16x12/gb.png',
  NL: 'https://flagcdn.com/16x12/nl.png',
  PL: 'https://flagcdn.com/16x12/pl.png',
  SE: 'https://flagcdn.com/16x12/se.png',
  BE: 'https://flagcdn.com/16x12/be.png',
  IE: 'https://flagcdn.com/16x12/ie.png',
};

const defaultThresholds = {
  profit: { high: 100, medium: 50, enabled: true },
  marge: { high: 30, medium: 15, enabled: true },
  roi: { high: 50, medium: 30, enabled: true },
};

function getThresholds() {
  try {
    const saved = localStorage.getItem('commandesThresholds');
    if (saved) return JSON.parse(saved);
  } catch {}
  return defaultThresholds;
}

const CommandesLiees = ({ commandes = [] }) => {
  const thresholds = getThresholds();

  // Tri du plus récent au plus ancien
  const sorted = [...commandes].sort((a, b) => new Date(b.DateCommande) - new Date(a.DateCommande));
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>Commandes</Typography>
                </Box>
                {
                (!commandes || commandes.length === 0)  &&
                (<Typography variant="caption" sx={{ color: '#888' }}>Aucune commande liée</Typography>)
                
                }

      {sorted.map(cmd => {
        const profit = Number(cmd.Profit);
        const marge = Number(cmd.Marge);
        const roi = Number(cmd.ROI);
        const profitColors = getColorForValue(profit, thresholds.profit);
        const margeColors = getColorForValue(marge, thresholds.marge);
        const roiColors = getColorForValue(roi, thresholds.roi);
        return (
          <Box
            key={cmd.id}
            sx={{
              px: 0.5,
              py: 0.7,
              borderRadius: 1.5,
              transition: 'background 0.15s',
              '&:hover': { background: '#f5f7fa' },
              mb: 0.2,
              minWidth: 0
            }}
          >
            {/* Ligne 1 : Date - Prix de vente - Marketplace */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1 }}>
              <Typography variant="body2" sx={{ color: '#222', fontWeight: 500, fontSize: 13 }}>{formatDateShort(cmd.DateCommande)}</Typography>
              <Typography variant="body2" sx={{ color: '#1976d2', fontWeight: 700, fontSize: 14 }}>{cmd.PrixDeVente !== undefined ? Number(cmd.PrixDeVente).toFixed(2) + ' €' : '-'}</Typography>
              {countryFlags[cmd.Pays] ? (
                <Tooltip title={cmd.Pays} arrow>
                  <img src={countryFlags[cmd.Pays]} alt={cmd.Pays} style={{ width: 16, height: 12, borderRadius: 2, border: '1px solid #eee' }} />
                </Tooltip>
              ) : (
                <Typography variant="caption" sx={{ color: '#888', fontSize: 12 }}>{cmd.Pays}</Typography>
              )}
            </Box>
            {/* Ligne 2 : Profit, Marge, ROI (badges colorés, alignés, avec labels) */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5, justifyContent: 'space-between' }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 44 }}>
                <Typography variant="caption" sx={{ fontSize: 10, color: '#888', mb: 0.1 }}>Profit</Typography>
                <Chip label={profit !== undefined ? Number(profit).toFixed(2) + ' €' : '-'} size="small" sx={{ bgcolor: profitColors.bg, color: profitColors.text, fontWeight: 600, height: 22, fontSize: 13, minWidth: 54, maxWidth: 80, whiteSpace: 'nowrap' }} />
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 44 }}>
                <Typography variant="caption" sx={{ fontSize: 10, color: '#888', mb: 0.1 }}>Marge</Typography>
                <Chip label={marge !== undefined ? Number(marge).toFixed(1) + ' %' : '-'} size="small" sx={{ bgcolor: margeColors.bg, color: margeColors.text, fontWeight: 600, height: 22, fontSize: 13, minWidth: 54, maxWidth: 80, whiteSpace: 'nowrap' }} />
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 44 }}>
                <Typography variant="caption" sx={{ fontSize: 10, color: '#888', mb: 0.1 }}>ROI</Typography>
                <Chip label={roi !== undefined ? Number(roi).toFixed(1) + ' %' : '-'} size="small" sx={{ bgcolor: roiColors.bg, color: roiColors.text, fontWeight: 600, height: 22, fontSize: 13,  minWidth: 54, maxWidth: 80, whiteSpace: 'nowrap' }} />
              </Box>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default CommandesLiees; 